import { ActionReducerMap } from '@ngrx/store';
import { AppState } from '../state/app.state';
import { activityReducer } from './activity.reducer';
import { assignmentReducer } from './assignment.reducer';
import { instructorAssignmentReducer } from './instructor.assignments.reducer';
import { ltiReducer } from './ltiparams.reducer';
import { moduleReducer } from './module.reducer';
import { questionReducer } from './question.reducer';

export const appReducers: ActionReducerMap<AppState, any> = {
  instructorAssignmentsState: instructorAssignmentReducer,
  moduleState: moduleReducer,
  currentActivityState: activityReducer,
  ltiParamsState: ltiReducer,
  assignmentState: assignmentReducer,
  questionAssessmentState: questionReducer,
};
